/**
 * Navigation configuration for Admin Layout
 *
 * Centralizes sidebar navigation items with optional permission support.
 * When permissions are implemented, items will be filtered based on user permissions.
 */
import type { LucideIcon } from 'lucide-react';
import { LayoutDashboard, Receipt, Users, FileText, Settings, UserCog, Banknote } from 'lucide-react';
import { APP_ROUTES } from './constants';

export interface NavItem {
  name: string;
  href: string;
  icon: LucideIcon;
  /**
   * Permission required to see this item.
   * If undefined, the item is visible to all authenticated users.
   * Example: 'gads.view', 'budgets.manage'
   */
  permission?: string;
}

/**
 * Main navigation items for the admin sidebar
 */
export const ADMIN_NAV_ITEMS: NavItem[] = [
  {
    name: 'Dashboard',
    href: APP_ROUTES.DASHBOARD,
    icon: LayoutDashboard,
    // No permission required - visible to all
  },
  {
    name: 'Partidas',
    href: APP_ROUTES.BUDGETS,
    icon: Receipt,
    // permission: 'budgets.view',
  },
  {
    name: 'Terceros',
    href: APP_ROUTES.PARTIES,
    icon: Users,
    // permission: 'parties.view',
  },
  {
    name: 'Empleados',
    href: APP_ROUTES.EMPLOYEES,
    icon: UserCog,
    // permission: 'employees.view',
  },
  {
    name: 'Roles de Pago',
    href: APP_ROUTES.PAYROLLS,
    icon: Banknote,
    // permission: 'payrolls.view',
  },
  {
    name: 'Justificaciones de Pago',
    href: APP_ROUTES.PAYMENT_JUSTIFICATIONS.ROOT,
    icon: FileText,
    // permission: 'payment_justifications.view',
  },
  {
    name: 'Configuraciones',
    href: APP_ROUTES.SETTINGS.ROOT,
    icon: Settings,
    // permission: 'settings.view',
  },
];
